/**
 * Newsletter popup facade: wait for first pointerdown/keydown, then the
 * configured delay, then load CSS/JS and open. Cookie skip still applies.
 */
(() => {
  const dialog = document.getElementById("newsletter-popup-modal");
  if (!dialog) return;

  const popup = dialog.querySelector("#newsletter-popup");
  const loader = window.BoltFeatureLoader;
  const assets = window.BoltAssets || {};
  const cssHref = assets.newsletterPopupCss || dialog.dataset.facadeCss;
  const jsSrc = assets.newsletterPopup || dialog.dataset.facadeJs;
  if (!popup || !loader || !cssHref || !jsSrc) return;

  const delayMs = Number(popup.dataset.configDelay || 5) * 1000;
  const daysToWait = Number(popup.dataset.configDaysToWait || 3);
  const path = popup.dataset.configPath || "newsletter-popup";
  const forceOpen = window.location.href.includes(path);
  const hasCookie = document.cookie.indexOf("ks-newsletter-popup") !== -1;

  if (hasCookie && !forceOpen) return;

  const createCookie = (name, value, days) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  };

  const openPopup = async () => {
    if (dialog.dataset.facadeBound === "true") return;
    dialog.dataset.facadeBound = "true";

    try {
      await Promise.all([
        loader.loadStylesheet(cssHref, "bolt-newsletter-css"),
        loader.loadScript(jsSrc, "bolt-newsletter-js"),
      ]);
      await customElements.whenDefined("newsletter-popup");

      if (!forceOpen) {
        createCookie("ks-newsletter-popup", true, daysToWait);
      }

      if (typeof dialog.showModal === "function" && !dialog.open) {
        dialog.showModal();
      }
    } catch (error) {
      console.error("Newsletter popup facade failed to load", error);
      dialog.dataset.facadeBound = "false";
    }
  };

  if (forceOpen) {
    setTimeout(openPopup, 500);
    return;
  }

  loader.onFirstInteraction(() => {
    setTimeout(openPopup, delayMs);
  });
})();
